import styled from 'styled-components';

const CircledNumber = styled.div`
&&& {
    display: flex;
    border-radius : 50%;
    box-sizing: border-box;
    background: #231F20;
    width: 32px;
    height: 32px;
    padding-top: 5px;
    color: #FFFFFF;
    align-self: center;
    justify-content: center;
    margin: ${({ theme }) => `
        ${theme.Spacing.spacing1x} ${theme.Spacing.spacing2x} ${theme.Spacing.spacing1x} ${theme.Spacing.spacing0x}
    `};
}
`;

export default CircledNumber;
